import { createApp } from 'vue'
import Filesync from './Filesync.vue';
import {mapLocalizationData} from '../../../common/vue/helper/LocalizationMapper'

document.addEventListener('DOMContentLoaded', () =>{
    let rootId = 'filesync';
    let rootElement = document.getElementById(rootId);

    if (rootElement) {
        let app = createApp(Filesync, {
                        loadFoldersUrl: rootElement.getAttribute('data-load-folders-url'),
                        fileSyncUrl: rootElement.getAttribute('data-file-sync-url'),
                        folderSyncUrl: rootElement.getAttribute('data-folder-sync-url'),
                        csrfToken: rootElement.getAttribute('data-csrf-token'),
                        fileBatchSize: parseInt(rootElement.getAttribute('data-file-batch-size')),
                        maxParallelRequests: parseInt(rootElement.getAttribute('data-max-parallel-requests')),
                        i18n: mapLocalizationData(rootElement),
                    });
        app.mount(rootElement);
    }
});
